/* eslint-disable react/prefer-es6-class */
import React from 'react';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export const SentenceTrainerQuizSettingsPanel = React.createClass({
  displayName: 'SentenceTrainerQuizSettingsPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('quiz settings');
    },
  },

  render() {
    return (
      <div className="quiz-settings">
        <div className="content-columns">
          <div className="content-column">
            {this._renderTypingSpecialCharactersToggle()}
          </div>
        </div>
      </div>
    );
  },
});

export default SentenceTrainerQuizSettingsPanel;
